export default "__VITE_ASSET__DJEjBe3f__"